/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RelationshipType } from './relationshipType';
import { Asset } from './asset';


export interface AssetRelation { 
    _id: string;
    relatedAsset: Asset;
    relationshipType: RelationshipType;
}

